import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon, FilterIcon, MoreVerticalIcon } from 'lucide-react';
const TeamLineups = () => {
  const [sortConfig, setSortConfig] = useState({
    key: 'minutes',
    direction: 'desc'
  });
  // Mock lineup data with enhanced information
  const lineupData = [{
    id: 1,
    players: [{
      name: 'Brunson',
      position: 'PG',
      avatar: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1629675.png'
    }, {
      name: 'Hart',
      position: 'SG',
      avatar: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1628404.png'
    }, {
      name: 'Anunoby',
      position: 'SF',
      avatar: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1628384.png'
    }, {
      name: 'Randle',
      position: 'PF',
      avatar: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1626162.png'
    }, {
      name: 'Hartenstein',
      position: 'C',
      avatar: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1628392.png'
    }],
    tags: ['STARTING 5', 'CLOSING'],
    team: 'NYK',
    teamLogo: 'https://cdn.nba.com/logos/nba/1610612752/primary/L/logo.svg',
    games: 28,
    record: '22-6',
    minutes: 245.5,
    minutesPct: 18.2,
    possessions: 650,
    pace: 99.5,
    offRtg: 118.2,
    defRtg: 106.8,
    netRtg: 11.4,
    netRtgPercentile: 95,
    fg2Pct: 56.8,
    fg3Pct: 41.2
  }, {
    id: 2,
    players: [{
      name: 'Brunson',
      position: 'PG',
      avatar: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1629675.png'
    }, {
      name: 'DiVincenzo',
      position: 'SG',
      avatar: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1628978.png'
    }, {
      name: 'Anunoby',
      position: 'SF',
      avatar: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1628384.png'
    }, {
      name: 'Randle',
      position: 'PF',
      avatar: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1626162.png'
    }, {
      name: 'Hartenstein',
      position: 'C',
      avatar: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1628392.png'
    }],
    tags: ['STARTING 5'],
    team: 'NYK',
    teamLogo: 'https://cdn.nba.com/logos/nba/1610612752/primary/L/logo.svg',
    games: 22,
    record: '17-5',
    minutes: 198.3,
    minutesPct: 15.8,
    possessions: 540,
    pace: 98.8,
    offRtg: 115.8,
    defRtg: 108.2,
    netRtg: 7.6,
    netRtgPercentile: 82,
    fg2Pct: 54.5,
    fg3Pct: 36.5
  }, {
    id: 3,
    players: [{
      name: 'Brunson',
      position: 'PG',
      avatar: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1629675.png'
    }, {
      name: 'Hart',
      position: 'SG',
      avatar: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1628404.png'
    }, {
      name: 'Barrett',
      position: 'SF',
      avatar: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1629628.png'
    }, {
      name: 'Randle',
      position: 'PF',
      avatar: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1626162.png'
    }, {
      name: 'Robinson',
      position: 'C',
      avatar: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1629011.png'
    }],
    tags: ['BENCH UNIT'],
    team: 'NYK',
    teamLogo: 'https://cdn.nba.com/logos/nba/1610612752/primary/L/logo.svg',
    games: 18,
    record: '13-5',
    minutes: 167.2,
    minutesPct: 12.5,
    possessions: 480,
    pace: 97.2,
    offRtg: 113.5,
    defRtg: 109.5,
    netRtg: 4.0,
    netRtgPercentile: 68,
    fg2Pct: 52.3,
    fg3Pct: 38.7
  }];
  // Sort lineups based on current sort configuration
  const sortedLineups = [...lineupData].sort((a, b) => {
    if (a[sortConfig.key] < b[sortConfig.key]) {
      return sortConfig.direction === 'asc' ? -1 : 1;
    }
    if (a[sortConfig.key] > b[sortConfig.key]) {
      return sortConfig.direction === 'asc' ? 1 : -1;
    }
    return 0;
  });
  // Handle sort request
  const requestSort = key => {
    let direction = 'desc';
    if (sortConfig.key === key && sortConfig.direction === 'desc') {
      direction = 'asc';
    }
    setSortConfig({
      key,
      direction
    });
  };
  // Render sort icon
  const renderSortIcon = key => {
    if (sortConfig.key !== key) return null;
    return sortConfig.direction === 'asc' ? <ChevronUpIcon className="w-3 h-3 inline ml-1" data-id="element-404" data-mp="1pknmwyl45pgj" /> : <ChevronDownIcon className="w-3 h-3 inline ml-1" data-id="element-405" data-mp="1plysn3y4d7aa" />;
  };
  // Render rating bar
  const renderRatingBar = (value, type: 'offense' | 'defense') => {
    const maxValue = type === 'offense' ? 125 : 115;
    const minValue = type === 'offense' ? 100 : 95;
    const percentage = (value - minValue) / (maxValue - minValue) * 100;
    const clampedPercentage = Math.max(0, Math.min(100, percentage));
    let color = 'bg-gray-300';
    if (type === 'offense') {
      if (value >= 118) color = 'bg-green-500';else if (value >= 112) color = 'bg-yellow-500';else color = 'bg-red-500';
    } else {
      if (value <= 106) color = 'bg-green-500';else if (value <= 110) color = 'bg-yellow-500';else color = 'bg-red-500';
    }
    return <div className="flex items-center gap-2" data-id="element-406" data-mp="360gv1ta807dw">
        <div className="w-16 h-1.5 bg-gray-200 rounded-full overflow-hidden" data-id="element-407" data-mp="uin3ua8n15fz">
          <div className={`h-full ${color} rounded-full`} style={{
          width: `${clampedPercentage}%`
        }} data-id="element-408" data-mp="pl3qrdnoeypm" />
        </div>
      </div>;
  };
  // Render percentage bar
  const renderPercentageBar = percentage => {
    let color = 'bg-orange-500';
    if (percentage >= 40) color = 'bg-green-500';else if (percentage >= 35) color = 'bg-yellow-500';else color = 'bg-red-500';
    return <div className="flex items-center gap-2" data-id="element-409" data-mp="6lzjoafp3f0l">
        <div className="w-16 h-1.5 bg-gray-200 rounded-full overflow-hidden" data-id="element-410" data-mp="6nan2958akr6">
          <div className={`h-full ${color} rounded-full`} style={{
          width: `${percentage}%`
        }} data-id="element-411" data-mp="kmk04zy50yqx" />
        </div>
      </div>;
  };
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200" data-id="element-412" data-mp="foqxuhzygovx">
      <div className="overflow-x-auto" data-id="element-413" data-mp="1vz31wn5vvg1a">
        <table className="min-w-full" data-id="element-414" data-mp="1r1td99qbj8ei">
          <thead data-id="element-415" data-mp="1r0rok2gdqneb">
            <tr className="border-b border-gray-200" data-id="element-416" data-mp="1r1b97qxezpw1">
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-417" data-mp="oooj7p1326xq">
                LINEUP COMPOSITION
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-418" data-mp="tp2s19aidkwt">
                TAGS
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-419" data-mp="12mv3g2d408ex">
                TEAM
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider cursor-pointer hover:text-gray-900" onClick={() => requestSort('games')} data-id="element-420" data-mp="9z8ra5ptfvgg">
                Games {renderSortIcon('games')}
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider cursor-pointer hover:text-gray-900" onClick={() => requestSort('minutes')} data-id="element-421" data-mp="jpu0so712ke5">
                MIN {renderSortIcon('minutes')}
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider cursor-pointer hover:text-gray-900" onClick={() => requestSort('possessions')} data-id="element-422" data-mp="3fumb4hj3sv7k">
                POSS {renderSortIcon('possessions')}
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider cursor-pointer hover:text-gray-900" onClick={() => requestSort('pace')} data-id="element-423" data-mp="35un4iq68vexc">
                PACE {renderSortIcon('pace')}
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider cursor-pointer hover:text-gray-900" onClick={() => requestSort('offRtg')} data-id="element-424" data-mp="2s5bhrl43233g">
                OFF RTG {renderSortIcon('offRtg')}
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider cursor-pointer hover:text-gray-900" onClick={() => requestSort('defRtg')} data-id="element-425" data-mp="2i8ozn4355q54">
                DEF RTG {renderSortIcon('defRtg')}
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider cursor-pointer hover:text-gray-900" onClick={() => requestSort('netRtg')} data-id="element-426" data-mp="x7y0c0zoddq">
                NET RTG {renderSortIcon('netRtg')}
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider cursor-pointer hover:text-gray-900" onClick={() => requestSort('fg2Pct')} data-id="element-427" data-mp="3o49zgmoa2m1l">
                2P% {renderSortIcon('fg2Pct')}
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider cursor-pointer hover:text-gray-900" onClick={() => requestSort('fg3Pct')} data-id="element-428" data-mp="3j3e0mnis9q31">
                3P% {renderSortIcon('fg3Pct')}
              </th>
              <th className="px-4 py-3 text-right" data-id="element-429" data-mp="39ayfjhc6wldx">
                <MoreVerticalIcon className="w-4 h-4 text-gray-400 inline" data-id="element-430" data-mp="2vekz8bje6q11" />
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100" data-id="element-431" data-mp="30btfu7ow6m06">
            {sortedLineups.map(lineup => <tr key={lineup.id} className="hover:bg-gray-50 transition-colors" data-id="element-432" data-mp="2grct3p4xxavx">
                <td className="px-4 py-4" data-id="element-433" data-mp="2bsrq5hyb0d3s">
                  <div className="flex items-center gap-3" data-id="element-434" data-mp="2btuepj85m3gj">
                    {lineup.players.map((player, index) => <div key={index} className="flex flex-col items-center" data-id="element-435" data-mp="2pp6azv1yk1zk" data-mpi={index}>
                        <div className="w-12 h-12 rounded-full overflow-hidden bg-gray-100 border-2 border-white shadow-sm" data-id="element-436" data-mp="2lome8slar0dy">
                          <img src={player.avatar} alt={player.name} className="w-full h-full object-cover" onError={e => {
                      e.currentTarget.src = 'https://via.placeholder.com/48x48/e5e7eb/6b7280?text=' + player.name.charAt(0);
                    }} data-id="element-437" data-mp="2znceui7bri72" />
                        </div>
                        <div className="mt-1 text-center" data-id="element-438" data-mp="3ig6hqdrobjux">
                          <div className="text-xs font-medium text-gray-900" data-id="element-439" data-mp="3igpyvs9i247w">
                            {player.name}
                          </div>
                          <div className="text-xs text-gray-500" data-id="element-440" data-mp="3myd3sblc4cgi">
                            {player.position}
                          </div>
                        </div>
                      </div>)}
                  </div>
                </td>
                <td className="px-4 py-4" data-id="element-441" data-mp="3d9bn0j6ytr1h">
                  <div className="flex flex-col gap-1" data-id="element-442" data-mp="389qpmd7g1qqv">
                    {lineup.tags.map((tag, index) => <span key={index} className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-700" data-id="element-443" data-mp="387w1yr4sfkj3" data-mpi={index}>
                        {tag}
                      </span>)}
                  </div>
                </td>
                <td className="px-4 py-4" data-id="element-444" data-mp="3vy9wcoauhvgu">
                  <div className="flex items-center gap-2" data-id="element-445" data-mp="3w1e4txvcfddb">
                    <img src={lineup.teamLogo} alt={lineup.team} className="w-8 h-8" onError={e => {
                  e.currentTarget.src = 'https://via.placeholder.com/32x32/e5e7eb/6b7280?text=' + lineup.team;
                }} data-id="element-446" data-mp="3qzf30sf94oih" />
                    <span className="text-sm font-semibold text-gray-900" data-id="element-447" data-mp="2fn5ynduvrgnu">
                      {lineup.team}
                    </span>
                  </div>
                </td>
                <td className="px-4 py-4" data-id="element-448" data-mp="102n3432zyqkj">
                  <div className="text-sm font-semibold text-gray-900" data-id="element-449" data-mp="151gk45hhszpg">
                    {lineup.games}
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-450" data-mp="19sykosflsy9w">{lineup.record}</div>
                </td>
                <td className="px-4 py-4" data-id="element-451" data-mp="1epygmaiqokna">
                  <div className="text-sm font-semibold text-gray-900" data-id="element-452" data-mp="1et2rfqqpmemx">
                    {lineup.minutes.toFixed(0)}
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-453" data-mp="1nreqmh5n6kqz">
                    {lineup.minutesPct.toFixed(1)}%
                  </div>
                </td>
                <td className="px-4 py-4" data-id="element-454" data-mp="1soomofnjduns">
                  <div className="text-sm text-gray-900" data-id="element-455" data-mp="3pjul9at74p1d">
                    {lineup.possessions}
                  </div>
                </td>
                <td className="px-4 py-4" data-id="element-456" data-mp="3uie77b7si0tq">
                  <div className="text-sm text-gray-900" data-id="element-457" data-mp="3mgws7t1p7f8m">
                    {lineup.pace.toFixed(1)}
                  </div>
                </td>
                <td className="px-4 py-4" data-id="element-458" data-mp="3ihfph7dnow75">
                  <div className="flex items-center gap-2" data-id="element-459" data-mp="9ylf2pw2ntw">
                    <span className="text-sm font-semibold text-gray-900" data-id="element-460" data-mp="bjfkr8ak4r8">
                      {lineup.offRtg.toFixed(1)}
                    </span>
                    {renderRatingBar(lineup.offRtg, 'offense')}
                  </div>
                </td>
                <td className="px-4 py-4" data-id="element-461" data-mp="5a4e8m7wagdk">
                  <div className="flex items-center gap-2" data-id="element-462" data-mp="578hv2bp3zr8">
                    <span className="text-sm font-semibold text-gray-900" data-id="element-463" data-mp="izocbeqj6pgj">
                      {lineup.defRtg.toFixed(1)}
                    </span>
                    {renderRatingBar(lineup.defRtg, 'defense')}
                  </div>
                </td>
                <td className="px-4 py-4" data-id="element-464" data-mp="nzsvxdmqk0az">
                  <div className={`text-sm font-bold ${lineup.netRtg >= 0 ? 'text-green-600' : 'text-red-600'}`} data-id="element-465" data-mp="o0vkhewl5qnq">
                    {lineup.netRtg > 0 ? '+' : ''}
                    {lineup.netRtg.toFixed(1)}
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-466" data-mp="1bl3j1p1bgip0">
                    {lineup.netRtgPercentile}%ile
                  </div>
                </td>
                <td className="px-4 py-4" data-id="element-467" data-mp="12lq80rxjnm26">
                  <div className="flex items-center gap-2" data-id="element-468" data-mp="12om6qih7uero">
                    <span className="text-sm font-semibold text-gray-900" data-id="element-469" data-mp="nwkbjbq3c9xz">
                      {lineup.fg2Pct.toFixed(1)}%
                    </span>
                    {renderPercentageBar(lineup.fg2Pct)}
                  </div>
                </td>
                <td className="px-4 py-4" data-id="element-470" data-mp="ev4153za07tr">
                  <div className="flex items-center gap-2" data-id="element-471" data-mp="jx34weyxh6r8">
                    <span className="text-sm font-semibold text-gray-900" data-id="element-472" data-mp="4yr7u77n7vzj">
                      {lineup.fg3Pct.toFixed(1)}%
                    </span>
                    {renderPercentageBar(lineup.fg3Pct)}
                  </div>
                </td>
                <td className="px-4 py-4 text-right" data-id="element-473" data-mp="1d7gdr85hjy36">
                  <button className="text-gray-400 hover:text-gray-600" data-id="element-474" data-mp="189wz474vljap">
                    <MoreVerticalIcon className="w-4 h-4" data-id="element-475" data-mp="18brivi4ev5d7" />
                  </button>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
      <div className="px-4 py-3 border-t border-gray-200 flex items-center justify-between" data-id="element-476" data-mp="yj2ch1npwhoq">
        <div className="text-sm text-gray-600" data-id="element-477" data-mp="tljzn06kxibg">Showing 1 to 3 of 3 results</div>
        <div className="flex gap-2" data-id="element-478" data-mp="pixf7kc8mzoa">
          <button className="px-3 py-1 text-sm text-gray-600 hover:text-gray-900 disabled:opacity-50" disabled data-id="element-479" data-mp="phvrafa4iip5">
            Previous
          </button>
          <button className="px-3 py-1 text-sm text-gray-600 hover:text-gray-900 disabled:opacity-50" disabled data-id="element-480" data-mp="fliyrkqbeavz">
            Next
          </button>
        </div>
      </div>
    </div>;
};
export default TeamLineups;